import { Dialog } from 'primereact/dialog'
import { useEffect, useState } from 'react'
import { JVDropdownInput } from '../../shared/JVDropdownInput';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { ICompanyMast } from '../../models/CompanyMast';
import { Fetch } from '../../shared/Fetch';
import { Button } from 'primereact/button';
import { ICityMastDropdown, IClientCompanyDropdown, IStateMastDropdown } from '../../models/IDropdown';
import { JVDate } from '../../shared/JVDate';
import { JVCheckbox } from '../../shared/JVCheckbox';
import { JVInput } from '../../shared/JVInput';
import { JVDropdown } from '../../shared/JVDropdown';
// import { ICompanyAuthorizedSignatory } from '../companyMast/CompanyAuthorizedSignatory';
// import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';
// import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { JVSunEditor } from '../../shared/JVSuneditor';
import { JVInputMask } from '../../shared/JVInputMask';
import { BillingCycle, PaymentTerm } from '../../models/PurchaseOrder';
// import { ISpecialClauseMast } from '../specialClauseMast/Form';
interface IProps {
    singleData: any;
    open: boolean;
    hideDialog: () => void;
    toast: any;
}

export interface IGeneratePo {
    id?: number,
    company_Name_Sales?: ICompany,
    sub_Vendor_Company?: IClientCompanyDropdown,
    pO_Date: Date | null,
    consultant_Name: string,
    consultant_ID?: number,
    pO_ID?: number,
    end_Client_Name: string,
    remote: boolean,
    state_Name?: {
        state_ID: number,
        state_Name: string
    },
    city_Name?: {
        city_ID: number,
        city_Name: string
    },
    project_Start_Date: Date | null,
    project_Duration: string,
    billing_Rate: number,
    prime_Vendor_Billing_Cycle: BillingCycle,
    prime_Vendor_Payment_Term: PaymentTerm,
    termination_Notice: string,
    signatory_Name: string,
    signatory_Designation: string,
    company_Address?: string,
    feid?: string,
    position_Title?: string,
    req_ID?: number,
    tax_Term?: string,
    clause?: string,
    is_Special_Clasue?: boolean
    special_Clause?: string
}

interface ICompany {
    company_ID?: number;
    company_Name?: string;
}
const schema = yup.object().shape({
    company_Name_Sales: yup.object({
        company_ID: yup.number(),
        company_Name: yup.string()
    }).required('Company Name Sales is required'),
    sub_Vendor_Company: yup.object({
        client_ID: yup.number(),
        client_Name: yup.string()
    }).required("Sub vendor Company Name is required"),
    // pO_Date: yup.date().nullable(true).required('PO Date is required'),
    consultant_Name: yup.string().required('Consultant Name is required'),
    end_Client_Name: yup.string().required('End Client Name is required'),
    remote: yup.boolean().nullable(),
    state_Name: yup.object({
        state_ID: yup.number().required('State ID is required'),
        state_Name: yup.string().required('State Name is required')
    }).nullable(true),
    city_Name: yup.object({
        city_ID: yup.number().required('City ID is required'),
        city_Name: yup.string().required('City Name is required')
    }).nullable(true),
    project_Start_Date: yup.date().nullable(true).required('Project Start Date is required'),
    project_Duration: yup.string().required('Project Duration is required'),
    billing_Rate: yup.number().required('Billing Rate is required').min(0, 'Billing Rate must be a positive value'),
    prime_Vendor_Billing_Cycle: yup.number().required('Billing Cycle is required'),
    prime_Vendor_Payment_Term: yup.number().required('Payment Term is required'),
    termination_Notice: yup.string().required('Termination Notice is required'),
    signatory_Name: yup.string().required('Signatory Name is required'),
    signatory_Designation: yup.string().required('Signatory Designation is required'),
    feid: yup.string().required('FEID is required'),
    position_Title: yup.string().required('Position Title is required'),
    is_Special_Clasue: yup.boolean().nullable(),
    special_Clause: yup.string().when('is_Special_Clasue', val => {
        return (val === true) ?
            yup.string().required("Special Clause Name required") :
            yup.string().nullable()
    }),
});

const termination_Notice = [{ name: "15 Days" }, { name: "21 Days" }, { name: "30 Days" }]

export const Payment_Term = [
    { name: "Net 30", id: PaymentTerm.Net_Thirty },
    { name: "Net 45", id: PaymentTerm.Net_Forty_Five },
    { name: "Pay on Pay", id: PaymentTerm.Pay_On_Pay },
    { name: "Net 15", id: PaymentTerm.Net_Fifteen },
    { name: "Net 60", id: PaymentTerm.Net_Sixty },
    { name: "Net 7", id: PaymentTerm.Net_Seven }
];
export const Billing_Cycle = [
    { name: "-- SELECT --", id: null },
    { name: "Weekly", id: BillingCycle.Weekly },
    { name: "Monthly", id: BillingCycle.Monthly },
    { name: "Bi-Weekly", id: BillingCycle.BiWeekly },
];

const sanitizeFormData = (data: any): IGeneratePo => {
    const {
        company_Name_Sales,
        sub_Vendor_Company,
        pO_Date,
        consultant_Name,
        end_Client_Name,
        remote,
        state_Name,
        city_Name,
        project_Start_Date,
        project_Duration,
        billing_Rate,
        prime_Vendor_Billing_Cycle,
        prime_Vendor_Payment_Term,
        termination_Notice,
        signatory_Name,
        signatory_Designation,
        company_Address,
        feid,
        position_Title,
        consultant_ID,
        pO_ID,
        req_ID,
        tax_Term
    } = data;

    return {
        company_Name_Sales,
        sub_Vendor_Company,
        pO_Date,
        consultant_Name,
        end_Client_Name,
        remote,
        state_Name,
        city_Name,
        project_Start_Date,
        project_Duration,
        billing_Rate,
        prime_Vendor_Billing_Cycle,
        prime_Vendor_Payment_Term,
        termination_Notice,
        signatory_Name,
        signatory_Designation,
        company_Address,
        feid,
        position_Title,
        consultant_ID,
        pO_ID,
        req_ID,
        tax_Term
    };
};


export const GeneratePO = (props: IProps) => {
    const [company, setCompany] = useState<ICompany[]>([])
    const [subVendorCompanies, setsubVendorCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    // const [signatory, setSignatory] = useState<ICompanyAuthorizedSignatory[]>([]);
    const [companyDetail, setCompanyDetail] = useState<ICompanyMast[]>([]);
    const [clause, setClause] = useState("");
    // const [specialClause, setSpecialClause] = useState<ISpecialClauseMast[]>([]);

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue, } = useForm<IGeneratePo>({
        resolver: yupResolver(schema),
        defaultValues: {
            ...props.singleData,
            project_Start_Date: props.singleData?.project_Start_Date ? new Date(props.singleData.project_Start_Date) : new Date(),
            pO_Date: props.singleData?.pO_Date ? new Date(props.singleData.pO_Date) : new Date(),
            company_Name_Sales: {
                company_ID: props.singleData?.company_ID_Sales,
                company_Name: props.singleData?.company_Name_Sales
            },
            sub_Vendor_Company: {
                vendor_Company_ID: props.singleData?.sub_Vendor_ID,
                vendor_Company_Name: props.singleData?.pO_Sub_Vendor_Company
            },
            state_Name: {
                state_ID: props.singleData?.state_ID,
                state_Name: props.singleData?.state_Name
            },
            city_Name: {
                city_ID: props.singleData?.city_ID,
                city_Name: props.singleData?.city_Name
            },
            billing_Rate: props.singleData?.sRate,
            project_Duration: props.singleData?.req_Duration,
            end_Client_Name: props.singleData?.project_Client_Name,
            position_Title: props.singleData?.project_Name,
            //  pO_ID:props.singleData?.pO_ID

        },
        shouldFocusError: false
    });
    const isRemote = watch('remote');
    const selectedSignatoryName = watch('signatory_Name');
    const special_Constraint = watch('is_Special_Clasue');



    useEffect(() => {
        reset({
            ...props.singleData,
            project_Start_Date: props.singleData?.project_Start_Date ? new Date(props.singleData.project_Start_Date) : new Date(),
            //  pO_Date: props.singleData?.pO_Date ? new Date(props.singleData.pO_Date) : new Date(),
            pO_Date: new Date(),
            company_Name_Sales: {
                company_ID: props.singleData?.company_ID_Sales,
                company_Name: props.singleData?.company_Name_Sales
            },
            sub_Vendor_Company: {
                vendor_Company_ID: props.singleData?.sub_Vendor_Company_ID,
                vendor_Company_Name: props.singleData?.pO_Sub_Vendor_Company
            }, state_Name: {
                state_ID: props.singleData?.state_ID,
                state_Name: props.singleData?.state_Name
            },
            city_Name: {
                city_ID: props.singleData?.city_ID,
                city_Name: props.singleData?.city_Name
            },
            billing_Rate: props.singleData?.sRate,
            project_Duration: props.singleData?.req_Duration,
            end_Client_Name: props.singleData?.project_Client_Name,
            position_Title: props.singleData?.project_Name,
            //    pO_ID:props.singleData?.pO_ID

        });
    }, [props.singleData])

    // useEffect(() => {
    //     const selectedSignatory = signatory.find(s => s.name === selectedSignatoryName);
    //     if (selectedSignatory) {
    //         setValue('signatory_Designation', selectedSignatory.designation || '');
    //     }
    // }, [selectedSignatoryName, signatory, setValue])


    const loadCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/getCompany", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<ICompany> = await response.json();
            setCompany(data);
        }
    }
    const completeMethodCompanies = (event: { query: string }) => {
        loadCompanies(event.query);
    }

    const loadsubClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setsubVendorCompanies(data);
        }
    }
    const completeMethodSubVendor = (event: { query: string }) => {
        loadsubClientCompanies(event.query);
    }
    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    const loadCities = async (filter: string | null) => {
        if (control._formValues.state_Name?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state_Name.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current?.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadCompanyLogo = async () => {
        const response = await Fetch('Company_Mast/getCompanyLogo', "GET", null, `comp_id=${props.singleData.company_ID_Sales}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            setCompanyDetail(data);
        }
    }

    // this is use for show image in pdf  
    // const signature = signatory.find(signatory => signatory.signature);
    // const signatureBase64 = `data:image/png;base64,${signature?.signature}`;

    const companyLogo = companyDetail.find(companyDetail => companyDetail.company_Logo);
    const companyLogoBase64 = `data:image/png;base64,${companyLogo?.company_Logo}`;


    useEffect(() => {
        if (companyLogo?.feid) {
            setValue('feid', companyLogo?.feid || "");
        }
    }, [companyLogo?.feid])

    const onSubmit = async (data: any) => {
        data.clause = clause;
        var htmlClauseString = data.clause;
        var plainClauseString = htmlClauseString
            // .replace(/<br\s*\/?>/gi, '\n') // Replace <br> with \n
            .replace(/<\/div>/gi, '\n') // Add line break at the end of </div>
            .replace(/<[^>]+>/g, ''); // Remove all other HTML tags // this is use to convert html into plain string
        var Clause = plainClauseString.replace(/&nbsp;/g, ' ').trim()
        console.log("Clause:-", Clause);
        console.log("plainClauseString:-", plainClauseString);
        console.log("htmlClauseString:-", htmlClauseString);

        const cityName = data?.city_Name?.city_Name;
        const stateName = data?.state_Name?.state_Name;
        data.city_Name = data.city_Name ? data.city_Name?.city_ID : data.city_Name;
        data.state_Name = data.state_Name ? data.state_Name?.state_ID : data.state_Name;
        data.sub_Vendor_Company = data.sub_Vendor_Company?.vendor_Company_Name
        const sanitizedData = sanitizeFormData(data);
        sanitizedData.company_Address = companyLogo?.company_Address;
        const response = await Fetch('vwPODetails/updateGeneratePo', "PUT", sanitizedData, null, props.toast)
        if (response) {
            props.toast.current?.show({ severity: 'success', detail: "Purchase Order Updated Successfully.", life: 3000 });
            onHide();
        }
        const companyLogoImage = companyLogoBase64 || ''; // Fallback to empty if undefined
        // const signatureImage = signatureBase64 || ''; // Fallback to empty if undefined
        // console.log(signatureBase64);
        // let logoImage;
        // if(signature?.signature==undefined){
        //     logoImage=`text: ''`;
        // }else{
        //     logoImage=`image: signatureBase64`;

        // }
    };

    const onHide = () => {
        props.hideDialog();
        setClause("");

    }

    useEffect(() => {
        if (props.open === true) {
            // getSignatory();
            loadCompanyLogo();
            // loadSpecialClause();
        }
    }, [props.open])


    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Update Generate PO" className="p-fluid" onHide={onHide} >
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdownInput disabled column={3} required completeMethod={completeMethodCompanies} label="Company" control={control} name="company_Name_Sales" options={company} error={errors.company_Name_Sales?.company_Name?.message} optionLabel="company_Name" placeholder="Search Company" />
                <JVDropdownInput column={3} required label="Sub Vendor" completeMethod={completeMethodSubVendor} control={control} name="sub_Vendor_Company" options={subVendorCompanies} error={errors.sub_Vendor_Company?.vendor_Company_Name?.message} optionLabel="vendor_Company_Name" placeholder="Search Sub Vendor" />
                {/* <JVDate column={4} required name='pO_Date' label='Date Of PO' control={control} error={errors.pO_Date?.message} /> */}
                <JVInput column={3} required label='Consultant Name' control={control} name='consultant_Name' error={errors.consultant_Name?.message} />
                <JVInput column={4} required label='End Client Name' control={control} name='end_Client_Name' error={errors.end_Client_Name?.message} />
                <div className=" field col-6 md:col-3 mt-4">
                    <p style={{ color: 'white' }}></p>
                    <JVCheckbox column={3} name='remote' label='Remote' control={control} error={errors.remote?.message} />
                </div>
                <JVDropdownInput required column={4} disabled={isRemote} completeMethod={completeMethodStates} label="State" control={control} name="state_Name" error={errors.state_Name?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                <JVDropdownInput required column={4} disabled={isRemote} completeMethod={completeMethodCities} label="City" control={control} name="city_Name" error={errors.city_Name?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
                <JVInput column={4} required label='Project Title' control={control} name='position_Title' error={errors.position_Title?.message} />
                <JVDate column={4} required name='project_Start_Date' label='Project Start Date' control={control} error={errors.project_Start_Date?.message} />
                <JVInput column={4} required label='Project Duration' control={control} name='project_Duration' error={errors.project_Duration?.message} />
                <JVInput column={4} required label='Billing Rate' control={control} name='billing_Rate' error={errors.billing_Rate?.message} />
                <JVDropdown column={4} required label='Billing Cycle' control={control} name='prime_Vendor_Billing_Cycle' options={Billing_Cycle} optionLabel='name' optionValue='id' placeholder='-- Select Termination Notice' error={errors.prime_Vendor_Billing_Cycle?.message} />
                <JVDropdown column={4} label="Payment Term" control={control} name="prime_Vendor_Payment_Term" options={Payment_Term} optionLabel="name" optionValue="id" placeholder="Select Payment Term" error={errors.prime_Vendor_Payment_Term?.message} />
                <JVDropdown column={4} required label='Termination Notice' control={control} name='termination_Notice' options={termination_Notice} optionLabel='name' optionValue='name' placeholder='-- Select Termination Notice' error={errors.termination_Notice?.message} />
                {/* <JVDropdown column={4} required label='Signatory Name' name='signatory_Name' control={control} options={signatory} optionLabel='name' optionValue='name' placeholder='-- Select Signatory--' error={errors.signatory_Name?.message} /> */}
                <JVInput column={4} required label='Signatory Designation' control={control} name='signatory_Designation' error={errors.signatory_Designation?.message} />
                {/* <JVInputMask column={4} required mask='99-9999999' label='FEID' control={control} name='feid' error={errors.feid?.message} /> */}
                <JVInputMask column={4} required mask='99-9999999' label='FEID' control={control} name='feid' error={errors.feid?.message} />
                <div className='field col-6 md:col-3 mt-4'>
                    <JVCheckbox column={4} label='Special Clause' name='is_Special_Clasue' control={control} />
                </div>
                {/* {special_Constraint === true && <JVDropdown required={true} column={4} label='Special Clause' name='special_Clause' control={control} options={specialClause} optionLabel='special_Clause' optionValue='special_Clause' error={errors.special_Clause?.message} />} */}
                {/* {special_Constraint === true && <JVSunEditor value={clause} handleChange={setClause} />} */}

                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" ></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    )
}
